import React, {useContext} from 'react'
import {useStaticQuery, graphql} from "gatsby"
import Img from "gatsby-image"
import {GlobalStateContext} from "../../../context/GlobalContextProvider"

const Resuemee2024 = (state) => {
    state = useContext(GlobalStateContext);

    const data = useStaticQuery(graphql`
        query {
            resuemee2024PDF: file(relativePath: { eq: "Publications/Scientific/resuemee2024.pdf" }) {
                name
                publicURL
            }
            resuemee2024Image: file(relativePath: { eq: "Publications/Scientific/research-gate.png" }) {
                childImageSharp {
                    fluid(maxWidth: 250, quality: 90) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            } 
        }
    `)

    return (
        <div className={state.publicationsId}>
            <div className="box">
                <div className="paper-container">
                    <div className="image-container">
                    <a href={data.resuemee2024PDF.publicURL} download>
                    <Img fluid={data.resuemee2024Image.childImageSharp.fluid} className="image"/> 
                    </a>
                    </div>
                    <div className="outside">
                        <div className="inside">  
                            <p>Résumé of the Gamified Increase in Security Awareness in KMU<br/> (2024)</p>
                            <p className="subtitle"><a href={data.resuemee2024PDF.publicURL}>DOI:10.13140/RG.2.2.13519.29600</a></p>
                        </div>
                    </div>    
                </div>
            </div>
        </div>
    )
};

export default Resuemee2024;